import styled from "styled-components";


export const Container = styled.div`
  opacity: 0;
  visibility: hidden;
  z-index: 10;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  &.show {
    opacity: 1;
    visibility: visible;
  }
`;

export const ContactPage = styled.div`
    display: flex;
    font-weight: 500px;
    font-size: 25px;
    color: white;
    width: 25%;
    height: 40rem;
    background-color: hsl(221, 48.7%, 7.6%);
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    z-index: 20;
    border-radius: 12px;
    padding-left: 3rem;
    padding-top: 3rem;
    flex-direction: column;
`

export const ContactHeader = styled.div`
    position: relative;
    font-weight: bold;
    font-size: 25px;
    left: -19%;
    padding-left: 4.2rem;
`

export const ContactSubText = styled.div`
  position: relative;
  font-size: 12px;
  opacity: 0.2;
  color: white;
  z-index: 20;
  left: -3%;
  padding-top: 1.5rem;
`

export const ContactTextBox = styled.input`
  position: relative;
  z-index: 25;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
  padding-left: 0.6rem;
  top: 1%;
  left: -3%;
  width: 85%;
  height: 7%;
  color: white;
  opacity: 0.7;
  font-size: 18px;
  background-color: hsl(221, 48.7%, 7.6%);
  outline: white;
  border: 1px solid white;
  border-radius: 6px;
  transition: 50ms ease;
  &:focus {
    border-color: white;
  }
`

export const ContactBody = styled.textarea`
  position: relative;
  z-index: 25;
  padding-top: 0.6rem;
  padding-left: 0.6rem;
  top: 1%;
  left: -3%;
  width: 85%;
  height: 30%;
  color: white;
  opacity: 0.8;
  font-size: 18px;
  font-family: Arial;
  background-color: hsl(221, 48.7%, 7.6%);
  outline: white;
  border: 1px solid white;
  border-radius: 6px;
  resize: none;
  transition: 50ms ease;
  &:focus {
    border-color: white;
  }
`

export const ContactCounter = styled.div`
  position: relative;
  font-size: 12px;
  opacity: 0.7;
  color:white;
  z-index: 25;
  text-align: right;
  top: -2%;
  left: -20%;
`

export const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0,0,0,0.8);
  z-index: 10;
`

export const ButtonCancel = styled.a`
  width: 30%;
  background-color: ${props => props.cta ? 'white' : 'transparent'};
  border: ${props => props.cta ? 'none' : '1px solid white'};
  color: ${props => props.cta ? '#091b3f' : 'white'};

  cursor: pointer;
  padding: 12px;
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    margin-right: ${props => props.cta ? '0.5rem' : '0'};
    margin-left: ${props => props.sa ? '0.5rem' : '0'};
  }
`

export const ButtonSend = styled.a`
  width: 51%;
  background-color: ${props => props.cta ? 'white' : 'transparent'};
  border: ${props => props.cta ? 'none' : '1px solid white'};
  color: ${props => props.cta ? '#091b3f' : 'white'};

  cursor: pointer;
  padding: 12px;
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    margin-right: ${props => props.cta ? '0.5rem' : '0'};
    margin-left: ${props => props.sa ? '0.5rem' : '0'};
  }
`


export const Buttons = styled.div`
  display: flex;
  position: relative;
  top: 2%;
  left: -2%;
  gap: 0.8rem;
`

;
